import Vue from 'vue'
import Router from 'vue-router'
import Cabaco from '@/components/Cabaco'
import Login from '@/components/Login'
import Logout from '@/components/Logout'
import SignIn from '@/components/SignIn'
Vue.use(Router)

let routes = [{
        path: '/',
        name: 'Cabaco',
        component: Cabaco,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/signin',
        name: 'Signin',
        component: SignIn,
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/logout',
        name: 'Logout',
        component: Logout,
    },
];

let router = new Router({
    mode: "history", // https://router.vuejs.org/api/#mode
    linkActiveClass: "active",
    scrollBehavior: () => ({ y: 0 }),
    routes: routes, // im using function to define all the routes. you can define routes here
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        console.log(sessionStorage.getItem("session"));
        if (sessionStorage.getItem("session") == null) {
            next({
                path: "/login",
                params: { nextUrl: to.fullPath },
            });
        } else {
            next();
            // if (!store.state.isAuthenticated) {
            //     next({
            //         path: "/login",
            //         params: { nextUrl: to.fullPath },
            //     });
            // } else {
            //     next();
            // }
        }
    } else {
        next();
    }
});


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js